import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl, FormArray } from '@angular/forms';

import { USER_ID } from '@prcins/constants';
import { Router } from '@angular/router';
import { PolicyProviderService } from '../services/policy-provider.service';
import { AdminService } from '../services/admin.service';
import { INotification, LoginService } from '@prcins/utils';

@Component({
  selector: 'prcins-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.css']
})
export class AdminHomeComponent implements OnInit {

  showSpinner = false;
  selectedActivity;
  notification: INotification;
  adminActivityForm: FormGroup = this.fb.group({
    activity: ['policyNumber'],
    activityInput: this.fb.array([])
  });

  policyInput: FormControl = new FormControl('', [Validators.required]);
  emailInput: FormControl = new FormControl('',
    [
      Validators.required,
      Validators.email,
      Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,4}$')
    ]);

  arrayInput: { name: string, label: string, formControl: FormControl }[];

  constructor(private fb: FormBuilder,
    private policyService: PolicyProviderService,
    private loginService: LoginService,
    private adminService: AdminService,
    private router: Router) {

    this.adminService.adminActivityError.subscribe(data => {
      this.notification = data;
    });
  }

  ngOnInit() {
    this.selectedActivity = this.activity.value;
    this.onActivityChange();
    this.adminActivityForm.get('activity').valueChanges.subscribe(val => {
      this.selectedActivity = val;
      this.onActivityChange();
    })
  }

  get activityInput() {
    return this.adminActivityForm.get('activityInput') as FormArray;
  }
  set activityInput(value: FormArray) { }

  get activity() {
    return this.adminActivityForm.get('activity') as FormControl;
  }

  onActivityChange() {
    switch (this.selectedActivity) {
      case "policyNumber":
        this.arrayInput = [];
        this.arrayInput.push({
          name: this.selectedActivity,
          label: "Policy Number",
          formControl: this.policyInput
        });

        this.activityInput.clear();
        this.arrayInput.map(({ formControl }) => { console.log(formControl); this.activityInput.push(formControl) });
        break;
      case "email":
        this.arrayInput = [];
        this.arrayInput.push({
          name: this.selectedActivity,
          label: "Email",
          formControl: this.emailInput
        });

        this.activityInput.clear();
        this.arrayInput.map(({ formControl }) => { console.log(formControl); this.activityInput.push(formControl) });
        break;
    }
  }

  onSubmit() {
    this.showSpinner = true;
    let { activity, activityInput: userInput } = this.adminActivityForm.value;
    switch (activity) {
      case 'policyNumber':
        this.policyService.getUserName(userInput[0]).subscribe(email => {
          if (email) {
            sessionStorage.setItem(USER_ID, email);
            this.router.navigate(['eservice/home']);
          } else {
            this.notification = { type: 'ERROR', message: "Policy Not Registered" };
          }
          this.showSpinner = false;
        });
        break;
      case 'email':
        const emailAddress = userInput[0];
        this.loginService.getActiveAccount(emailAddress).subscribe(accountInfo => {
          if (accountInfo.active) {
            this.router.navigate(['eservice/admin/activity/delete'], { queryParams: { email: emailAddress } });
          } else {
            this.notification = { type: 'ERROR', message: "Email Account Not Found" };
          }
          this.showSpinner = false;
        });
        // this.loginService.getRegisteredPolicies(emailAddress).subscribe(registeredPolicies => {
        //   if (registeredPolicies.length >= 0) {
        //     this.router.navigate(['eservice/admin/activity/delete'], { queryParams: { email: emailAddress } });
        //   } else {
        //     this.notification = { type: 'ERROR', message: "Email Account Not Found" };
        //   }
        //   this.showSpinner = false;
        // });
        break;

    }

  }



}
